import { useEffect, useRef, useState } from "react";
import { UnpackData } from "../../helper/functionSensor";
import { lightGreen, blue, purple } from "@mui/material/colors";

// graph
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ChartData,
} from "chart.js";
import { Line } from "react-chartjs-2";
import zoomPlugin from "chartjs-plugin-zoom";
import { Buffer } from "buffer";
import { MQTTI } from "../../helper/mqttClient";
import { Box } from "@mui/material";

let fft = require("fft-js").fft,
  fftUtil = require("fft-js").util;

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  zoomPlugin
);

const fftx = [
  0.0, 0.09765625, 0.1953125, 0.29296875, 0.390625, 0.48828125, 0.5859375,
  0.68359375, 0.78125, 0.87890625, 0.9765625, 1.07421875, 1.171875, 1.26953125,
  1.3671875, 1.46484375, 1.5625, 1.66015625, 1.7578125, 1.85546875, 1.953125,
  2.05078125, 2.1484375, 2.24609375, 2.34375, 2.44140625, 2.5390625, 2.63671875,
  2.734375, 2.83203125, 2.9296875, 3.02734375, 3.125, 3.22265625, 3.3203125,
  3.41796875, 3.515625, 3.61328125, 3.7109375, 3.80859375, 3.90625, 4.00390625,
  4.1015625, 4.19921875, 4.296875, 4.39453125, 4.4921875, 4.58984375, 4.6875,
  4.78515625, 4.8828125, 4.98046875, 5.078125, 5.17578125, 5.2734375,
  5.37109375, 5.46875, 5.56640625, 5.6640625, 5.76171875, 5.859375, 5.95703125,
  6.0546875, 6.15234375, 6.25, 6.34765625, 6.4453125, 6.54296875, 6.640625,
  6.73828125, 6.8359375, 6.93359375, 7.03125, 7.12890625, 7.2265625, 7.32421875,
  7.421875, 7.51953125, 7.6171875, 7.71484375, 7.8125, 7.91015625, 8.0078125,
  8.10546875, 8.203125, 8.30078125, 8.3984375, 8.49609375, 8.59375, 8.69140625,
  8.7890625, 8.88671875, 8.984375, 9.08203125, 9.1796875, 9.27734375, 9.375,
  9.47265625, 9.5703125, 9.66796875, 9.765625, 9.86328125, 9.9609375,
  10.05859375, 10.15625, 10.25390625, 10.3515625, 10.44921875, 10.546875,
  10.64453125, 10.7421875, 10.83984375, 10.9375, 11.03515625, 11.1328125,
  11.23046875, 11.328125, 11.42578125, 11.5234375, 11.62109375, 11.71875,
  11.81640625, 11.9140625, 12.01171875, 12.109375, 12.20703125, 12.3046875,
  12.40234375, 12.5, 12.59765625, 12.6953125, 12.79296875, 12.890625,
  12.98828125, 13.0859375, 13.18359375, 13.28125, 13.37890625, 13.4765625,
  13.57421875, 13.671875, 13.76953125, 13.8671875, 13.96484375, 14.0625,
  14.16015625, 14.2578125, 14.35546875, 14.453125, 14.55078125, 14.6484375,
  14.74609375, 14.84375, 14.94140625, 15.0390625, 15.13671875, 15.234375,
  15.33203125, 15.4296875, 15.52734375, 15.625, 15.72265625, 15.8203125,
  15.91796875, 16.015625, 16.11328125, 16.2109375, 16.30859375, 16.40625,
  16.50390625, 16.6015625, 16.69921875, 16.796875, 16.89453125, 16.9921875,
  17.08984375, 17.1875, 17.28515625, 17.3828125, 17.48046875, 17.578125,
  17.67578125, 17.7734375, 17.87109375, 17.96875, 18.06640625, 18.1640625,
  18.26171875, 18.359375, 18.45703125, 18.5546875, 18.65234375, 18.75,
  18.84765625, 18.9453125, 19.04296875, 19.140625, 19.23828125, 19.3359375,
  19.43359375, 19.53125, 19.62890625, 19.7265625, 19.82421875, 19.921875,
  20.01953125, 20.1171875, 20.21484375, 20.3125, 20.41015625, 20.5078125,
  20.60546875, 20.703125, 20.80078125, 20.8984375, 20.99609375, 21.09375,
  21.19140625, 21.2890625, 21.38671875, 21.484375, 21.58203125, 21.6796875,
  21.77734375, 21.875, 21.97265625, 22.0703125, 22.16796875, 22.265625,
  22.36328125, 22.4609375, 22.55859375, 22.65625, 22.75390625, 22.8515625,
  22.94921875, 23.046875, 23.14453125, 23.2421875, 23.33984375, 23.4375,
  23.53515625, 23.6328125, 23.73046875, 23.828125, 23.92578125, 24.0234375,
  24.12109375, 24.21875, 24.31640625, 24.4140625, 24.51171875, 24.609375,
  24.70703125, 24.8046875, 24.90234375, 25.0, 25.09765625, 25.1953125,
  25.29296875, 25.390625, 25.48828125, 25.5859375, 25.68359375, 25.78125,
  25.87890625, 25.9765625, 26.07421875, 26.171875, 26.26953125, 26.3671875,
  26.46484375, 26.5625, 26.66015625, 26.7578125, 26.85546875, 26.953125,
  27.05078125, 27.1484375, 27.24609375, 27.34375, 27.44140625, 27.5390625,
  27.63671875, 27.734375, 27.83203125, 27.9296875, 28.02734375, 28.125,
  28.22265625, 28.3203125, 28.41796875, 28.515625, 28.61328125, 28.7109375,
  28.80859375, 28.90625, 29.00390625, 29.1015625, 29.19921875, 29.296875,
  29.39453125, 29.4921875, 29.58984375, 29.6875, 29.78515625, 29.8828125,
  29.98046875, 30.078125, 30.17578125, 30.2734375, 30.37109375, 30.46875,
  30.56640625, 30.6640625, 30.76171875, 30.859375, 30.95703125, 31.0546875,
  31.15234375, 31.25, 31.34765625, 31.4453125, 31.54296875, 31.640625,
  31.73828125, 31.8359375, 31.93359375, 32.03125, 32.12890625, 32.2265625,
  32.32421875, 32.421875, 32.51953125, 32.6171875, 32.71484375, 32.8125,
  32.91015625, 33.0078125, 33.10546875, 33.203125, 33.30078125, 33.3984375,
  33.49609375, 33.59375, 33.69140625, 33.7890625, 33.88671875, 33.984375,
  34.08203125, 34.1796875, 34.27734375, 34.375, 34.47265625, 34.5703125,
  34.66796875, 34.765625, 34.86328125, 34.9609375, 35.05859375, 35.15625,
  35.25390625, 35.3515625, 35.44921875, 35.546875, 35.64453125, 35.7421875,
  35.83984375, 35.9375, 36.03515625, 36.1328125, 36.23046875, 36.328125,
  36.42578125, 36.5234375, 36.62109375, 36.71875, 36.81640625, 36.9140625,
  37.01171875, 37.109375, 37.20703125, 37.3046875, 37.40234375, 37.5,
  37.59765625, 37.6953125, 37.79296875, 37.890625, 37.98828125, 38.0859375,
  38.18359375, 38.28125, 38.37890625, 38.4765625, 38.57421875, 38.671875,
  38.76953125, 38.8671875, 38.96484375, 39.0625, 39.16015625, 39.2578125,
  39.35546875, 39.453125, 39.55078125, 39.6484375, 39.74609375, 39.84375,
  39.94140625, 40.0390625, 40.13671875, 40.234375, 40.33203125, 40.4296875,
  40.52734375, 40.625, 40.72265625, 40.8203125, 40.91796875, 41.015625,
  41.11328125, 41.2109375, 41.30859375, 41.40625, 41.50390625, 41.6015625,
  41.69921875, 41.796875, 41.89453125, 41.9921875, 42.08984375, 42.1875,
  42.28515625, 42.3828125, 42.48046875, 42.578125, 42.67578125, 42.7734375,
  42.87109375, 42.96875, 43.06640625, 43.1640625, 43.26171875, 43.359375,
  43.45703125, 43.5546875, 43.65234375, 43.75, 43.84765625, 43.9453125,
  44.04296875, 44.140625, 44.23828125, 44.3359375, 44.43359375, 44.53125,
  44.62890625, 44.7265625, 44.82421875, 44.921875, 45.01953125, 45.1171875,
  45.21484375, 45.3125, 45.41015625, 45.5078125, 45.60546875, 45.703125,
  45.80078125, 45.8984375, 45.99609375, 46.09375, 46.19140625, 46.2890625,
  46.38671875, 46.484375, 46.58203125, 46.6796875, 46.77734375, 46.875,
  46.97265625, 47.0703125, 47.16796875, 47.265625, 47.36328125, 47.4609375,
  47.55859375, 47.65625, 47.75390625, 47.8515625, 47.94921875, 48.046875,
  48.14453125, 48.2421875, 48.33984375, 48.4375, 48.53515625, 48.6328125,
  48.73046875, 48.828125, 48.92578125, 49.0234375, 49.12109375, 49.21875,
  49.31640625, 49.4140625, 49.51171875, 49.609375, 49.70703125, 49.8046875,
  49.90234375,
];

function FFTGraph({ typeSensor, PG, topic }) {
  let divRef = useRef({});

  // inisiasi variabel
  const defArrX = Array.apply(null, Array(1024)).map(() => 0);
  const defArrY = Array.apply(null, Array(1024)).map(() => 0);
  const defArrZ = Array.apply(null, Array(1024)).map(() => 0);
  const [bufferFFT, setBuffer] = useState({
    "Accelerometer X": defArrX,
    "Accelerometer Y": defArrY,
    "Accelerometer Z": defArrZ,
  });

  const optGraph = {
    maintainAspectRatio: true,
    responsive: true,
    animation: false,
    redraw: false,
    scales: {
      x: {
        ticks: {
          callback: (value, index) => {
            if (fftx.length > 0 && index % 2 === 0) {
              return fftx[index].toFixed(0) + " Hz";
            }
          },
        },
      },
      y: {
        min: 0,
        suggestedMax: 0.5,
        ticks: {
          callback: (value) => {
            return value + " Mag";
          },
        },
      },
    },
    elements: {
      point: {
        radius: 0,
        hoverRadius: 0,
        hitRadius: 0,
      },
      line: {
        tension: 0,
      },
    },
    title: {
      display: false,
    },
  };

  const dataDefaultX = {
    labels: fftx,
    datasets: [
      {
        id: 1,
        label: "FFT (Fast Fourier Transformation) X",
        data: [],
        borderColor: lightGreen["600"],
        backgroundColor: lightGreen["600"],
        fill: false,
        borderWidth: 1.5,
        hidden: false,
      },
    ],
  };
  const dataDefaultY = {
    labels: fftx,
    datasets: [
      {
        id: 1,
        label: "FFT (Fast Fourier Transformation) Y",
        data: [],
        borderColor: blue["600"],
        backgroundColor: blue["600"],
        fill: false,
        borderWidth: 1.5,
        hidden: false,
      },
    ],
  };
  const dataDefaultZ = {
    labels: fftx,
    datasets: [
      {
        id: 1,
        label: "FFT (Fast Fourier Transformation) Z",
        data: [],
        borderColor: purple["600"],
        backgroundColor: purple["600"],
        fill: false,
        borderWidth: 1.5,
        hidden: false,
      },
    ],
  };

  const [dataGraph, setData] = useState({
    "Accelerometer X": dataDefaultX,
    "Accelerometer Y": dataDefaultY,
    "Accelerometer Z": dataDefaultZ,
  });

  const bufferProcessing = async (newData, key) => {
    // // input data 100 baru
    bufferFFT[key] = await bufferFFT[key].concat(newData);
    // // remove data 100 lama
    bufferFFT[key].splice(0, newData.length);
  };

  // render graph
  const createGraph = () => {
    let graphs = [];
    for (let i = 0; i < PG.length; i++) {
      const key = PG[i].name;
      graphs.push(
        <div
          key={key}
          className="bg-white shadow p-4 mb-4"
          style={{
            backgroundColor: "white",
            borderRadius: "10px",
            width: "100%",
          }}
        >
          <Line
            ref={(ref) => (divRef.current[key] = ref)}
            options={optGraph}
            data={dataGraph[key]}
          />
        </div>
      );
    }
    return graphs;
  };

  // listener
  useEffect(() => {
    const instance = MQTTI().subscribe(topic);
    instance.on("message", (topic, buffer) => {
      if (divRef.current !== null) {
        // const payload = { topic, message: buffer.toString() }
        const dataMentah = buffer.toString().split(",")[1];
        const dataSensor = UnpackData(typeSensor.group, dataMentah);
        if (dataSensor !== undefined) {
          for (let i = 0; i < PG.length; i++) {
            const key = PG[i].name;
            // console.log("dataSensor", dataSensor[key]);
            bufferProcessing(dataSensor[key], key);
            // console.log(key)
            // FFT Processing harus array
            const phasors = fft(bufferFFT[key]);

            // Sample rate and coef is just used for length, and frequency step
            const frequencies = fftUtil.fftFreq(phasors, 100);
            const magnitudes = fftUtil.fftMag(phasors);
            const dataPlotFFT = frequencies.map(function (f, ix) {
              return magnitudes[ix] / 36;
            });

            // Plot to graph fft
            // dataGraph[key].datasets[0].data = dataPlotFFT;

            // console.log("F", key, divRef.current[key].data.labels);
            // console.log("Mag", key, dataPlotFFT);
            divRef.current[key].data.datasets[0].data = dataPlotFFT;
            divRef.current[key].update("quiet");
          }
        }
      }
    });
    return () => {
      instance.end();
      console.log("Unrender fft");
    };
  }, []);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
      }}
    >
      {createGraph()}
    </div>
  );
}

export default FFTGraph;
